import {
  ATTACHMENT_FILES,
  DECISION_MANAGER_FIELD_NAME,
  DOCUMENT_TITLE_FIELD_NAME,
  REFERENCE_MEMBER_FIELD_NAME,
} from "config/documentConstant";
import { DocumentTempSaveRequestWithAny } from "../hooks/create/useSaveTempDoc";
import { DocumentAttachmentFileRequest } from "apis/data-contracts";
import { TempDocumentDetailResponseWithAny } from "../hooks/queries/useTempDocumentDetailQuery";

export interface DocumentForm {
  [DOCUMENT_TITLE_FIELD_NAME]?: string;
  [ATTACHMENT_FILES]: DocumentAttachmentFileRequest[];
  [DECISION_MANAGER_FIELD_NAME]: string;
  [REFERENCE_MEMBER_FIELD_NAME]: string[];
}

interface GetTempSaveRequestProps<T> {
  documentClassName: string;
  documentClassUuid: string;
  form: T;
  tagUuids: string[];
  freeTagUuids: string[];
  companyUuid?: string;
  provinceName?: string;
  cityName?: string;
  lastLevel?: number;
  link?: string;
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}

/**
 * @description 임시 저장용 데이터를 객체로 반환하는 함수
 */
const getTempSaveRequest = <T extends DocumentForm>({
  documentClassName,
  documentClassUuid,
  form,
  tagUuids,
  freeTagUuids,
  companyUuid,
  provinceName,
  cityName,
  lastLevel,
  link,
}: GetTempSaveRequestProps<T>): DocumentTempSaveRequestWithAny => {
  if (!documentClassUuid) {
    throw Error("문서 Class의 UUID를 찾을 수 없습니다.");
  }

  const { decisionManager, referenceMember, attachmentFiles, ...documentData } =
    form;

  return {
    name: form.title || documentClassName,
    documentClassUuid,
    documentData,
    tagUuids,
    freeTagUuids,
    companyUuid,
    documentAttachmentFileList: attachmentFiles,
    provinceName,
    cityName,
    lastLevel,
    link,
  };
};

export default getTempSaveRequest;
